<h2>Welcome to the KX Food System!</h2>
<h3>How to use this infographic:</h3>
<img
  src="/assets/img/Food System Vis Instructions-11.svg"
  alt="Click on information hot spots to learn more about a topic within the food system. Click on headers to learn more about each step of the food system."
/>
